// extracted by css-extract-rspack-plugin
export default {"ChartCardDescriptionText":"Description-module__ChartCardDescriptionText__E4Zp6"};